export const BUSINESS_INFO = {
  name: "Ses Multi Service",
  cvr: "35998098",
  phone: "40949540",
  phoneFormatted: "40 94 75 40",
  email: "sesmultiservice2026@gmail.com",
  address: "8950 Ørsted",
  postalAndCity: "8950 Ørsted",
  fullAddress: "8950 Ørsted",
  area: "Norddjurs",
  coverageAreaText: "Baseret i Ørsted (8950) kører vi ud til sommerhuse og ferieboliger i hele Norddjurs, herunder Fjellerup Strand, Bønnerup Strand, Auning, Allingåbro, Vivild, Udbyhøj og omegn.",
  facebookUrl: "https://www.facebook.com/profile.php?id=61588774247369&locale=da_DK",
  primaryServices: [
    "Rengøring af sommerhuse",
    "Rengøring af Airbnb",
    "Tømning af dødsbo, derefter rengøring",
    "Rengøring af hus eller lejlighed"
  ],
  secondaryService: "Hundeklip & vask (under 10 kg)"
};

export const IMAGES = {
  exterior: "https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=85,format=auto/assets/161db869-3b85-456e-973a-3a2fd3e99bfc/danish-summerhouse-exterior.png",
  kitchen: "https://assets.auxodev.dk/cdn-cgi/image/width=1000,quality=85,format=auto/assets/161db869-3b85-456e-973a-3a2fd3e99bfc/bright-clean-kitchen.png",
  livingroom: "https://assets.auxodev.dk/cdn-cgi/image/width=1000,quality=85,format=auto/assets/161db869-3b85-456e-973a-3a2fd3e99bfc/cozy-airbnb-livingroom.png",
  bedroom: "https://assets.auxodev.dk/cdn-cgi/image/width=1000,quality=85,format=auto/assets/161db869-3b85-456e-973a-3a2fd3e99bfc/fresh-made-bedroom.png",
  bathroom: "https://assets.auxodev.dk/cdn-cgi/image/width=1000,quality=85,format=auto/assets/161db869-3b85-456e-973a-3a2fd3e99bfc/clean-modern-bathroom.png",
  dogGrooming: "https://assets.auxodev.dk/cdn-cgi/image/width=1000,quality=85,format=auto/assets/161db869-3b85-456e-973a-3a2fd3e99bfc/shutterstock-2595498599.jpg",
  dogDetail: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/161db869-3b85-456e-973a-3a2fd3e99bfc/dog-wash-grooming-detail.png",
  houseApartment: "/_assets/rengoering-hus-lejlighed.png",
  estateClearance: "/_assets/doedsbo-toemning-rengoering.png",
  clientReal1: "https://assets.auxodev.dk/cdn-cgi/image/width=1000,quality=85,format=auto/assets/161db869-3b85-456e-973a-3a2fd3e99bfc/imgi-2-761615491-122104351323292474-5126698008421474433-n.jpg",
  clientReal2: "https://assets.auxodev.dk/cdn-cgi/image/width=1000,quality=85,format=auto/assets/161db869-3b85-456e-973a-3a2fd3e99bfc/imgi-21-760620825-10162331829201879-6991498589267761897-n.jpg",
  clientReal3: "https://assets.auxodev.dk/cdn-cgi/image/width=1000,quality=85,format=auto/assets/161db869-3b85-456e-973a-3a2fd3e99bfc/imgi-21-761272825-122103779079292474-6780947939771872411-n.jpg"
};

export const GALLERIES = [
  {
    slug: "sommerhusrengoering",
    title: "Sommerhusrengøring Galleri",
    description: "Se udvalget af rene og indbydende sommerhuse klargjort til ejere og leje gæster.",
    images: [
      { url: IMAGES.clientReal1, caption: "Ses Multi Service – grundig rengøring i Norddjurs" },
      { url: IMAGES.clientReal2, caption: "Professionel klargøring og rengøring" },
      { url: IMAGES.clientReal3, caption: "Rengøring af ferie- og sommerhuse" },
      { url: IMAGES.exterior, caption: "Moderne dansk sommerhus i Norddjurs" },
      { url: IMAGES.kitchen, caption: "Klargjort og skinnende rent køkken" },
      { url: IMAGES.bedroom, caption: "Friskredt og støvfrit soveværelse" },
      { url: IMAGES.bathroom, caption: "Pletfrit badeværelse" }
    ]
  },
  {
    slug: "airbnb-rengoering",
    title: "Airbnb-rengøring Galleri",
    description: "Klargøring af ferieboliger og Airbnb-udlejning med øje for alle detaljer.",
    images: [
      { url: IMAGES.clientReal2, caption: "Ses Multi Service – effektiv Airbnb rengøring" },
      { url: IMAGES.clientReal1, caption: "Indbydende og rent feriehus" },
      { url: IMAGES.livingroom, caption: "Indbydende stue klar til næste gæst" },
      { url: IMAGES.kitchen, caption: "Grundigt aftørret køkkenområde" },
      { url: IMAGES.bathroom, caption: "Saniteret og rent badeværelse" },
      { url: IMAGES.bedroom, caption: "Indbydende soveareal" }
    ]
  },
  {
    slug: "hundeklip",
    title: "Hundeklip & Vask Galleri",
    description: "Kærlig pleje, klip og vask af små hunde under 10 kg.",
    images: [
      { url: IMAGES.dogGrooming, caption: "Nyklippet og ren lille hund" },
      { url: IMAGES.dogDetail, caption: "Skånsomme plejeprodukter og udstyr" }
    ]
  }
];

export const WHY_CHOOSE_US = [
  {
    title: "Kvalitet",
    description: "Aftaleprocessen med os er både hurtig og nem. Du kan nemt finde den tid, der passer dig bedst, og vi sørger for at imødekomme dine behov. Vi værdsætter din tid og stræber efter at gøre det så enkelt som muligt for dig.",
    icon: "fa-sparkles"
  },
  {
    title: "Kontakt",
    description: "Der oprettes en kontakt for hver kundeaftale, hvor frekvensen for opgavens udførelse, samt den aftalte pris, dokumenteres. Denne procedure sikrer, at begge parter er enige om vilkårene og mindsker risikoen for misforståelser. Det er vigtigt at holde disse oplysninger opdaterede for at sikre en optimal samarbejdsrelation.",
    icon: "fa-file-signature"
  },
  {
    title: "Henvendelse",
    description: "Vi er fleksible, hurtige til at besvare henvendelser og effektive i vores arbejde. Vores fokus er altid på at levere et flot resultat, der imødekommer dine behov. Din tilfredshed er vores prioritet, og vi stræber efter at overgå dine forventninger.",
    icon: "fa-comments"
  },
  {
    title: "Bestilling af flere ydelser",
    description: "En kunde kan bestille flere forskellige ydelser. Bestillingsprocessen foregår typisk ved, at kunden vælger de ønskede ydelser fra vores udvalg, og der bliver udtrykt dette ved det uforpligtende besøg fra Ses Multi Service. Der bliver lavet kontrakt på hver opgave. Hvis der er spørgsmål omkring bestillingen, kan kunden altid kontakte Ses Multi Service for hjælp.",
    icon: "fa-list-check"
  }
];

export const PRODUCTS_AND_EQUIPMENT = {
  intro: "I forhold til produkter, klude og mopper har jeg alt med til at udføre opgaven i dit sommerhus",
  subIntro: "Jeg bruger miljøvenlige produkter som ikke skader mig eller materialerne som er i dit sommerhus.",
  cleaningHeading: "Produkter til Rengøring fra",
  cleaningLinks: [
    { name: "suztain.com", url: "https://suztain.com/" },
    { name: "micare.dk", url: "https://micare.dk/" },
    { name: "nowas.dk", url: "https://www.nowas.dk/" }
  ],
  dogCareHeading: "Produkter i forhold til hundepleje",
  dogCareLinks: [
    { name: "cotonshoppen.dk", url: "https://cotonshoppen.dk/" },
    { name: "luksushund.dk", url: "https://www.luksushund.dk/" }
  ]
};

export const ABOUT_OWNER = {
  heading: "Hvem står bag Ses Multi Service?",
  ownerName: "Sofia Emmy Skafsgaard",
  ownerDetails: "62 år, gift. Mor til 4 og har 8 børnebørn.",
  trustpilotUrl: "https://www.trustpilot.com/review/sessuperren.dk",
  paragraphs: [
    "Jeg hedder Sofia Emmy Skafsgaard, 62 år, gift. Mor til 4 og har 8 børnebørn.",
    "Siden 2004-2008 har jeg været uddannet social- og sundhedshjælper og assistent.",
    "Jeg har fra 2014 til 2025 haft rengøringsfirmaet Ses Super Ren som startede op i Ørum ved Viborg og ved vores flytning til Vejle / Fredericia i 2017, hvor jeg startede med at have nye kunder der.",
    "Jeg tog i sommeren 2024 rengøringsleder uddannelsen på TEC Odense.",
    "Ses Super Ren er solgt til Anastasia, som var en af mine medarbejdere, som har kørt det videre i samme ånd.",
    "På Trustpilot kan du læse anmeldelser om den service, jeg har givet kunderne (alt før 1. okt. 2025).",
    "Jeg vil gøre mit bedste for at give dit sommerhus en ny friskhed, så du kan have tilfredse kunder som lejer dit sommerhus. Så de kan have fokus på at holde ferie og ikke på om der er gjort godt nok rent.",
    "Jeg har haft private / erhvervskunder fra 1 time om ugen til 25 timer om ugen.",
    "Jeg arbejdede en del år med sommerhus rengøring i Høll, Hvidbjerg og Mørkholt.",
    "Jeg har arbejdet på Skive Soldaterhjem som køkkenassistent. I en periode efter at jeg har solgt firmaet Ses Super Ren."
  ],
  restartSection: {
    heading: "Nu er jeg startet op igen:",
    points: [
      "Savnede kundekontakten og fandt ud af at der er et behov for den hjælp som jeg kan tilbyde med rengøring af sommerhuse og hundeklip.",
      "Jeg udfører alle opgaverne som det er nu men håber på at få så travlt at jeg kan ansætte nogle nye medarbejdere.",
      "Jeg kører primært i Ørsted, Allingåbro og Fjellerup området.",
      "Jeg har alt udstyret med til rengøring af dit sommerhus, Jeg ser frem til at komme forbi dit sommerhus med et uforpligtende tilbud.",
      "Hundebad og klip foregår på vores private adr.",
      "Ind imellem har jeg også et par udekørende vagter i hjemmeplejen Allingåbro.",
      "Jeg ser frem til at høre fra dig i forhold til Rengøringsopgaven eller hundeklip"
    ]
  }
};

export const VERBATIM_TEXTS = {
  sommerhus: {
    heading: "Rengøring af sommerhus",
    body: "Oplev grundigt sommerhus rengøring med Ses Multi Service, hvor du får aftørret alle flader, støvsuget og vasket gulv.\n\nVi tjekker fejl og mangler, og kan sende billeder, hvis noget skulle være i stykker.\n\nVores mål er effektiv rengøring, hver gang – for at sikre din tilfredshed og et skinnending rent sommerhus!"
  },
  airbnb: {
    heading: "Rengøring af Airbnb",
    body: "Oplev effektiv rengøring med Ses Multi Service!\n\nVi tilbyder grundig rengøring af dit Airbnb, tilpasset dine behov\n\nVores professionelle team sikrer, at dit hjem altid er rart og indbydende.\n\nHer kan vi også give jer besked om fejl og mangler."
  },
  hundeklip: {
    heading: "Hunde bad og klip",
    body: "Hos Ses Multi Service tilbyder jeg klip og vask af din hund under 10 kg.\n\nLav en fast aftale, så din hunds pels bliver velplejet og nem at håndtere.\n\nJeg sikrer en tryg og behagelig oplevelse for din firbenede ven!"
  },
  doedsbo: {
    heading: "Tømning af dødsbo, derefter rengøring",
    shortDesc: "Værdig, respektfuld og professionel tømning af dødsbo med efterfølgende komplet slutrengøring.",
    body: "Hos Ses Multi Service tilbyder vi komplet og nænsom hjælp til tømning af dødsbo samt efterfølgende grundig rengøring. Vi sørger for, at boligen efterlades fuldstændig ryddet og skinnende ren – klar til syn, udlejning eller salg."
  },
  husLejlighed: {
    heading: "Rengøring af hus eller lejlighed",
    shortDesc: "Grundig privat rengøring af helårshuse og lejligheder i Norddjurs – både enkeltstående eller faste aftaler.",
    body: "Få et skinnende rent hjem uden besvær. Vi klarer grundig rengøring af både huse og lejligheder med miljøvenlige midler og professionelt udstyr, tilpasset netop dit hjem og dine behov."
  }
};
